module.exports = __webpack_public_path__ + "static/media/humaaansdos.a12e91af.png";